import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, apiUrl } from "../../../utils/apis";
import type {
  Client,
  ClientApiResponse,
} from "./types";

export const clientApi = createApi({
  reducerPath: "clientApi",

  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem("token");
      headers.set("Content-Type", "application/json");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),

  tagTypes: ["Client"],

  endpoints: (builder) => ({

    // ✅ Get Client List (with search)
    getClientList: builder.query<
      ClientApiResponse,
      { search?: string; search_by?: string }
    >({
      query: (params) => ({
        url: apiUrl.clientApi, // make sure this exists
        method: "GET",
        params,
      }),
      providesTags: [{ type: "Client", id: "LIST" }],
    }),

    // ✅ Get Client Details by ID
    getClientDetails: builder.query<Client, number | string>({
      query: (id) => ({
        url: `${apiUrl.clientApi}${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [
        { type: "Client", id },
      ],
    }),

  }),
});

export const {
  useGetClientListQuery,
  useGetClientDetailsQuery,
  useLazyGetClientListQuery,
} = clientApi;
